import Navbar from "./Navbar/NavBar";
import {Col, Layout, Typography} from "antd";
import React from "react";

function References() {
    return (
        <Layout style={{backgroundColor: '#FFFFFF', minHeight: '100dvh'}}>
            <div style={{position: 'sticky', top: 0, zIndex: 10000}}>
                <Navbar/>
            </div>
            <Layout.Content style={{display: "flex", flexDirection: "column", backgroundColor: '#FFFFFF', gap: 10, paddingLeft:'2vw',  paddingTop:'2vh'}}>
                <Typography.Title level={2}>PhiSiCal-Checkup Citations</Typography.Title>
                <Col>
                    P.R. Amarasinghe, L. Allison, C.J. Morton, P.J. Stuckey, M. Garcia de la Banda, A.M. Lesk, & A.S. Konagurthu, PhiSiCal-Checkup: A Bayesian framework to validate amino acid conformations within experimental protein structures, Proc. Natl. Acad. Sci. U.S.A. 122 (1) e2416301121,
                    <a href={"https://doi.org/10.1073/pnas.2416301121"} target="_blank" rel="noreferrer">https://doi.org/10.1073/pnas.2416301121</a> (2025).

                </Col>
            </Layout.Content>
            <Layout.Footer style={{width: '100%', textAlign: 'right', zIndex: 1000, backgroundColor: "#58B2DC"}}><b>About
                <a href="https://lcb.infotech.monash.edu/phisical/" target="_blank" rel="noreferrer"
                   style={{color: "#1402f6"}}> 𝜙𝛹𝜒al</a> |
                <a href="https://lcb.infotech.monash.edu/" target="_blank" rel="noreferrer"
                   style={{color: "#1402f6"}}> LCB Home</a> |v1.0.0 </b>
            </Layout.Footer>
        </Layout>
    );
}
export default References;